export default __webpack_public_path__ + "static/tabsSectionBg-27e055f777c8744a629f04525e579576.png";